import { AddCommentBody, Comment, CommentResponse, UpdateCommentParams } from '@core/models/comment.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class CommentService {
    private readonly addCommentURL = `/comments/add_comment`;
    private readonly deleteCommentURL = `/comments/delete_comment`;
    private readonly updateCommentURL = `/comments/update_comment`;
    private readonly getAllCommentsURL = `/comments/get_all_Comments`;
    // ---------------------------------------------------------------

    addComment(body: AddCommentBody) {
        return fetchWithRetry(API.post(this.addCommentURL, body));
    }

    deleteComment(commentId: number) {
        return fetchWithRetry(API.delete(`${this.deleteCommentURL}/commentId=${commentId}`));
    }

    updateComment(params: UpdateCommentParams) {
        return fetchWithRetry(
            API.patch(`${this.updateCommentURL}/commentId=${params.commentId}?isVisible=${params.isVisible}`)
        );
    }

    getAllComments() {
        return fetchWithRetry(API.get<CommentResponse>(this.getAllCommentsURL));
    }
}

export default new CommentService();
